/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the primary-practitioner / panel (rostering) model of care: patients have a primary practitioner, may be asked to choose one, are auto-assigned from their first visit, and practitioners carry a panel with an availability rating. This is the family-practice care model — a specialty or episodic-care clinic leaves it off. Off when absent.
 * Turning it off hides the picker and roster surfaces; it does NOT clear Patient.primary_physician, so the field keeps working as a most-responsible-provider reference and re-enabling is lossless.
 * NOTE: refill requests depend on this module — a refill is stamped with the patient's primary practitioner, so with no primary it cannot route. See tenantFeatures.refillRequests.enabled().
 * @export
 * @interface ContinuityOfCareModule
 */
export interface ContinuityOfCareModule {
    /**
     * 
     * @type {boolean}
     * @memberof ContinuityOfCareModule
     */
    enabled?: boolean;
    /**
     * When true, subscribing marks the patient as needing to choose a primary practitioner, and the booking flow asks them to before continuing. When false, a primary can still be set, just never demanded.
     * @type {boolean}
     * @memberof ContinuityOfCareModule
     */
    require_selection?: boolean;
    /**
     * When true, a patient with no primary practitioner is assigned the practitioner from their first appointment (if that practitioner is a valid, accepting primary).
     * @type {boolean}
     * @memberof ContinuityOfCareModule
     */
    auto_assign?: boolean;
    /**
     * Target panel size per practitioner — the denominator behind the high/medium/low availability rating shown in the primary picker. Absent = no panel model: availability is simply not rated, and suggestions are returned unrated. There is deliberately NO default, because the founding tenant's 650 is not a figure any other clinic chose.
     * @type {number}
     * @memberof ContinuityOfCareModule
     */
    panel_target?: number;
    /**
     * Practitioner types eligible to be a primary practitioner, matched against Physician.physician_type. Absent = ['Nurse Practitioner'] (the founding tenant's model). An empty array means no type restriction. Never a blanket bypass — types like Phlebotomist must not become assignable by accident.
     * @type {Array<string>}
     * @memberof ContinuityOfCareModule
     */
    primary_physician_types?: Array<string>;
}

/**
 * Check if a given object implements the ContinuityOfCareModule interface.
 */
export function instanceOfContinuityOfCareModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContinuityOfCareModuleFromJSON(json: any): ContinuityOfCareModule {
    return ContinuityOfCareModuleFromJSONTyped(json, false);
}

export function ContinuityOfCareModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContinuityOfCareModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'require_selection': !exists(json, 'require_selection') ? undefined : json['require_selection'],
        'auto_assign': !exists(json, 'auto_assign') ? undefined : json['auto_assign'],
        'panel_target': !exists(json, 'panel_target') ? undefined : json['panel_target'],
        'primary_physician_types': !exists(json, 'primary_physician_types') ? undefined : json['primary_physician_types'],
    };
}

export function ContinuityOfCareModuleToJSON(value?: ContinuityOfCareModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'require_selection': value.require_selection,
        'auto_assign': value.auto_assign,
        'panel_target': value.panel_target,
        'primary_physician_types': value.primary_physician_types,
    };
}

